// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"1ca6677c","257":"0d83cb82","506":"b79050b7","635":"3ab63236"}[chunkId] + ".chunk.css";
};